import { render, staticRenderFns } from "./AppointmentHx.vue?vue&type=template&id=775886f6"
import script from "./AppointmentHx.vue?vue&type=script&lang=js"
export * from "./AppointmentHx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports